<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        append-to-body
        class="invoice-discount-confirm-dialog"
        width="500px"
        top="5vh"
        :before-close="onClose"
        :show-close="showClose"
    >
        <div class="detail-row">
            <div class="detail-block">
                <div class="title">
                    <slot name="title" />
                </div>
                <div class="sub-title">
                    <slot name="sub-title" />
                </div>
                <slot />
                <div class="button-set">
                    <el-button type="primary" @click="onConfirm">
                        {{ primaryText }}
                    </el-button>
                    <el-button v-if="normalText" type="" style="margin-left: 0; margin-top: 20px" plain @click="onClose">
                        {{ normalText }}
                    </el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        primaryText: String,
        normalText: String,
        showClose: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        onClose() {
            this.$emit('close');
        },
        onConfirm() {
            this.$emit('confirmed');
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.invoice-discount-confirm-dialog {
    .detail-block {
        .title {
            text-align: center;
            color: $main-color;
            font-size: 13pt;
            font-weight: bold;
            margin-bottom: 20px;
        }
        .sub-title {
            width: fit-content;
            margin: auto;
        }
    }
    .button-set {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 40px;
    }
    .el-dialog__headerbtn {
        transition: background-color 0.3s;
        width: 25px;
        height: 25px;
        top: 50%;
        background-color: #c7b9e4;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
            background-color: #ffffff72;
        }
        i {
            color: #fff;
            font-size: 18px;
            font-weight: bold;
        }
    }
    .el-dialog__header {
        position: relative;
    }
}
</style>

<style lang="scss">
.invoice-discount-confirm-dialog .el-select {
    width: 100% !important;
}
</style>
